

















export default

	props:
		item: Object
		active: Boolean

	computed:
		classes: -> 'active' if @active

		href: -> @item.href?

